// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from '../../duck';
import SendForgotPasswordModal from '../components/SendForgotPasswordModal/SendForgotPasswordModal';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    isSendingForgotPassword: state.authModals.isSendingForgotPassword,
    sendForgotPasswordError: state.authModals.sendForgotPasswordError,
    sendForgotPasswordSuccess: state.authModals.sendForgotPasswordSuccess,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SendForgotPasswordModal);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/forgot-password-modal/container/SendForgotPasswordModalContainer.js